export const capitalizeEachWord = (string) => {
  return string
    .split(" ") // Split the string into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
    .join(" "); // Rejoin the words into a single string
};
